// extracted by mini-css-extract-plugin
export var container = "_sw-0";
export var table = "_sw-2";
export var tableWrapper = "_sw-1";